<template>
    <div>
        <header-layout :fo_config="fo_config" :settingsConfig="settingsConfig"></header-layout>
        <div class="container">
            <breadcrumbs 
                title1="Nos prestations" desc1="Selection de prestation" 
                title2="Selectionner une date et une heure" desc2="Selection de créneau" 
                title3="Log-in" desc3="Connexion pour vous identifier"
                :step="step">
            </breadcrumbs>
            <div class="prestation-card">
                <slot></slot>
            </div>
        </div>
        <footer-layout></footer-layout>        
    </div>
</template>

<script>
import { Inertia } from "@inertiajs/inertia";
import { Link } from "@inertiajs/inertia-vue3";
import { toast } from "bulma-toast";
import HeaderLayout from "../SharedComponents/Header.vue";
import FooterLayout from "../SharedComponents/Footer.vue";
import Breadcrumbs from "../SharedComponents/Breadcrumbs.vue";
import axios from "axios";


axios.interceptors.response.use(function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response;
  }, function (error) {
    console.log('error ---->',error);
    if (error.response && error.response.status === 401) {
            // Use router.push() to navigate to the login screen
            window.location.href = '/booking'
            
            toast({
                    message: 'Session Expirée',
                    type: 'is-warning',
                    duration: 300000,
                    pauseOnHover: true
                })
            // Throw an exception to stop further execution
            return Promise.reject('Unauthorized');
    }
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    return Promise.reject(error);
  });

export default {
    components: { HeaderLayout, FooterLayout, Breadcrumbs },
    name: 'BookingLayout',
    remember: ["agenda_id", "location_id", "category_id"],
    props: ['fo_config', "settingsConfig", 'step'],
    // data() {
    //   return {
    //   //   filtered_agendas: [],
    //     agenda_id: null,
    //     category_id: null,
    //     is_categories_sorted: false,
    //     categories: [],
    //     location_id: null,
    //     prestations_to_show: [],
    //     selected_prestations: [],
    //   };
    // },
    // methods: {
    //   addPrestation(prestation) {
    //     if (this.isSelected(prestation)) return false;
    //     if (this.config.prestation_groupe_enable && prestation.is_group)
    //       this.selected_prestations = [];
    //     if (
    //       prestation.is_group &&
    //       prestation.allow_subgroup &&
    //       !prestation.group_size
    //     )
    //       prestation.group_size = 1;
    //     this.selected_prestations.push(prestation);
    //   },
    //   getPrestationImagePath(prestation) {
    //     let host = window.location.host.split(".");
    //     if (!host[1]) return false;
    //     let subdomain = host.shift();
    //     return (
    //       window.location.protocol +
    //       "//" +
    //       this.cdn_subdomain +
    //       "." +
    //       host.join(".") +
    //       "/datas/" +
    //       subdomain +
    //       "/images/prestations/" +
    //       prestation.image
    //     );
    //   },
    //   isSelectable(prestation) {
    //     if (this.selected_prestations.length === 0) return true;
    //     if (!this.config.prestation_combo_enable) return false;
    //     if (prestation.is_group) return false;
    //     if (this.selected_prestations[0].is_group) return false;
    //     return true;
    //   },
    //   isSelected(prestation) {
    //     return this.selected_prestations.find(
    //       (presta) => prestation.prestation_id == presta.prestation_id
    //     );
    //   },
    //   parseUrl() {
    //     const urlParams = new URLSearchParams(window.location.search);
    //     if (urlParams.get("agenda_id") && parseInt(urlParams.get("agenda_id")))
    //       this.agenda_id = urlParams.get("agenda_id");
    //     if (
    //       urlParams.get("location_id") &&
    //       parseInt(urlParams.get("location_id"))
    //     )
    //       this.location_id = urlParams.get("location_id");
    //     if (
    //       urlParams.get("category_id") &&
    //       parseInt(urlParams.get("category_id"))
    //     )
    //       this.category_id = urlParams.get("category_id");
    //   },
    //   removeAllPrestation() {
    //     this.selected_prestations = [];
    //   },
    //   removePrestation(prestation) {
    //     this.selected_prestations = this.selected_prestations.filter(
    //       (presta) => prestation.prestation_id != presta.prestation_id
    //     );
    //   },
    //   renderLocationAddress(location) {
    //     if (!location.address) return ''
    //     let localisation_regex = /((\-?|\+?)?\d+(\.\d+)?),\s*((\-?|\+?)?\d+(\.\d+)?)/
    //     return location.address.split(' ').filter(elt => !elt.match(localisation_regex)).join(' ')
    //   },
    //   save() {
    //     if (this.config.force_fo_agenda_selection && !this.agenda_id) {
    //       return toast({
    //         message:
    //           "Le choix du prestataire est obligatoire pour passer à l'étape suivante.",
    //         type: "is-warning",
    //         duration: 4000,
    //         pauseOnHover: true,
    //       });
    //     }

    //     if (this.selected_prestations.length === 0) {
    //       return toast({
    //         message: "Merci de choisir au moins une prestation.",
    //         type: "is-warning",
    //         duration: 4000,
    //         pauseOnHover: true,
    //       });
    //     }

    //     let query = {};
    //     query.prestation_id = this.selected_prestations.map(
    //       (prestation) => {
    //           // Calcul du prix
    //           query.price = 0;
    //           query.price += prestation.price;
    //           return prestation.prestation_id
    //       }
    //     );
    //     if (this.location_id) query.location_id = this.location_id;
    //     if (this.agenda_id) query.agenda_id = this.agenda_id;

    //     if (this.selected_prestations.find((prestation) => prestation.is_group)) {
    //       if (this.selected_prestations.length > 1) {
    //         return toast({
    //           message:
    //             "Impossible de combiner les prestations de groupe avec d'autre prestations.",
    //           type: "is-danger",
    //           duration: 4000,
    //           pauseOnHover: true,
    //         });
    //       }
    //       let prestation = this.selected_prestations[0];
    //       if (!prestation.allow_subgroup) query.group_size = 1;
    //       else query.group_size = prestation.group_size || 1;
    //       query.price = prestation.price*query.group_size;
    //     }
    //     let query_string = new URLSearchParams(query).toString();
    //     let route = "/times";
    //     if (query_string) route += "?" + query_string;
    //     this.$inertia.get(route);
    //   },
    //   setCategories() {
    //       this.categories = [];
    //       let categories = this.prestations.map((prestation) => prestation.categories).flat();
    //       for (let categorie of categories) {
    //               if (!this.categories.find((cat) => cat.category_id == categorie.category_id))
    //               this.categories.push(categorie);
    //       }
    //   },
    //   setPrestasWithoutCategory(){
    //       for (let i = 0; i < this.prestations.length; i++) {
    //           if(this.prestations[i].categories.length === 0){
    //               this.prestations[i].categories.push({
    //                   bo_description: "",
    //                   bo_name: "",
    //                   category_id: -1,
    //                   color: null,
    //                   enabled: null,
    //                   fo_description: "",
    //                   fo_name: "Autres",
    //                   image: null,
    //                   pivot: null,
    //                   position: null
    //               })
    //           }
    //       }
    //   },
    //   setDefaultAgenda() {
    //     if (this.client_rdvs.length === 0) return null;

    //     let orderedRdvs = this.client_rdvs.sort(
    //       (a, b) =>
    //         new Date(a.start_date).getTime() < new Date(b.start_date).getTime()
    //     );
    //     let last_rdv = orderedRdvs[0];
    //     this.agenda_id = last_rdv.agenda_id;
    //   },
    //   setGroupSize(e, prestation) {
    //     let group_size = e.target.value;
    //     let selected_prestation = this.selected_prestations.find(
    //       (p) => p.prestation_id == prestation.prestation_id
    //     );
    //     selected_prestation.group_size = group_size;
    //   },
    //   setPrestations() {
    //     let prestations = this.prestations;
    //     let query = {};
    //     if (this.agenda_id) {
    //       prestations = prestations.filter((prestation) =>
    //         prestation.agendas.find(
    //           (agenda) => agenda.agenda_id == this.agenda_id
    //         )
    //       );
    //       query.agenda_id = this.agenda_id;
    //     }
    //     if (this.location_id) {
    //       prestations = prestations.filter((prestation) =>
    //         prestation.agendas.find(
    //           (agenda) => agenda.location_id == this.location_id
    //         )
    //       );
    //       query.location_id = this.location_id;
    //     }
    //     if (this.category_id) {
    //       prestations = prestations.filter((prestation) =>
    //         prestation.categories.find(
    //           (category) => category.category_id == this.category_id
    //         )
    //       );
    //       query.category_id = this.category_id;
    //     }
    //     this.prestations_to_show = prestations;
    //   },

    //   changeFilters() {
    //     let query = {};
    //     if (this.agenda_id) {
    //       query.agenda_id = this.agenda_id;
    //     }
    //     if (this.location_id) {
    //       query.location_id = this.location_id;
    //     }
    //     if (this.category_id) {
    //       query.category_id = this.category_id;
    //     }
    //   },
    //   onCategoryTagClicked(id){
    //       this.category_id = id;
    //       this.changeFilters();
    //   },

    //   getPrestaionsByLocation(location_id, prestations){
    //       let filtered = [];
    //       for (let presta of prestations) {
    //           let agenda = presta.agendas.find(item => item.location_id === location_id);
    //           if(agenda){
    //               filtered.push(presta);
    //           }
    //       }
    //       return filtered;
    //   },
    // //   setBodyStyle(){
    // //       document.body.style.backgroundColor = this.theme['--body-bg-color'];
    // //   }
    // },

    // beforeMount(){
    //   this.setPrestasWithoutCategory();
    // },

    // mounted() {
    // //   this.setBodyStyle();
    //   if(this.fo_config){
    //       this.fo_config["filter"].sort((prev, next) => prev.position - next.position);
    //   }
    //   this.setCategories();
    //   this.parseUrl();
    //   this.setPrestations();
    //   if (this.locations.length > 0) this.location_id = this.locations[0].location_id;
    // },
}

</script>